/**
 * @file Created on Wed Aug 08 2018
 * @author PKl
 */
import Divider from './Divider';
export default Divider;
export { DividerType } from './DividerType';